<template>
  <RevButtonCard
    class="px-16 py-24"
    target="_blank"
    :to="{
      name: INSURANCE.POST_PURCHASE,
      query: {
        orderlineId: props.eligibleInsurance.orderlineId,
      },
    }"
    :tracking="{
      zone: trackingZone,
      name: 'go-to-eligible-insurance',
      productTitle: eligibleInsurance.productTitle,
      price: i18n.price(eligibleInsurance.offerMinPrice),
      remainingTime: eligibilityTime,
    }"
  >
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-4">
        <RevIllustration
          :alt="eligibleInsurance.productTitle"
          :height="72"
          :src="eligibleInsurance.productImage"
          :width="72"
        />
        <div class="space-y-4">
          <div class="body-1-bold">{{ eligibleInsurance.productTitle }}</div>
          <div class="text-static-brand-hi body-2">
            {{ eligibilityTime }}
          </div>
          <div class="text-static-brand-hi body-2">
            {{
              i18n(translations.startingPrice, {
                price: i18n.price(eligibleInsurance.offerMinPrice),
              })
            }}
          </div>
        </div>
      </div>

      <IconChevronRight />
    </div>
  </RevButtonCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButtonCard } from '@ds/components/ButtonCard'
import { RevIllustration } from '@ds/components/Illustration'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import { INSURANCE } from '~/scopes/insurance/routes.constants'

import type { EligibleInsurance } from '../../types'

import translations from './EligibleInsuranceCard.translations'

const i18n = useI18n()

const props = defineProps<{
  eligibleInsurance: EligibleInsurance
  trackingZone: string
}>()

const HOUR_IN_MILLISECONDS = 1000 * 60 * 60

const eligibilityTime = computed(() => {
  const hoursLeft =
    (new Date(props.eligibleInsurance.eligibilityEndDate).getTime() -
      Date.now()) /
    HOUR_IN_MILLISECONDS

  if (hoursLeft > 24) {
    const daysLeft = Math.ceil(hoursLeft / 24)

    return i18n(translations.daysLeft, { daysLeft })
  }

  if (hoursLeft < 1) {
    return i18n(translations.hoursLeft, { hoursLeft: 1 })
  }

  return i18n(translations.hoursLeft, { hoursLeft: Math.floor(hoursLeft) })
})
</script>
